import { Tooltip } from "antd";
import { useEffect, useState } from "react";

const Select = ({
  item,
  tooltip,
  input,
  inputName,
  withPlaceholder = true,
  data,
  placeholder,
}) => {
  const [option, setOption] = useState(null);
  useEffect(() => {
    setOption((Array.isArray(input.options) ? input.options : [])
      .find(opt =>
        opt.value === (item ? item[inputName] : data[inputName])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _v = option ? (
    option.outputLabel ? option.outputLabel
      : option.label
        ? option.label
        : placeholder(item || data, inputName, withPlaceholder)
  ) : placeholder(item, inputName, withPlaceholder);

  if (tooltip) {
    return <Tooltip title={_v}>{_v}</Tooltip>
  }

  return _v;
};

export default Select;
